module.exports = __webpack_public_path__ + "static/media/letterHeadTop.07dfb8e6.jpg";